import { createAction } from "redux-starter-kit";
import {
  EDIT_ARTICLE_PANEL_CHANGE_MODE,
  EDIT_ARTICLE_PANEL_SET_ARTICLE,
  EDIT_ARTICLE_PANEL_SNAPSHOT_META,
  EDIT_ARTICLE_PANEL_RECOVER_META,
  EDIT_ARTICLE_PANEL_UPDATE_META_TEXT,
  EDIT_ARTICLE_PANEL_RECOVER_CONTENT,
  EDIT_ARTICLE_PANEL_UPDATE_CONTRI_NAME,
  EDIT_ARTICLE_PANEL_LOCK_ID,
  EDIT_ARTICLE_PANEL_API_SET_TEXT,
  EDIT_ARTICLE_PANEL_SET_ITEM,
  EDIT_ARTICLE_PANEL_APPEND_CONTENT,
  EDIT_PANEL_ARTICLE_DELETE_CONTENT,
  EDIT_ARTICLE_PANEL_SNAPSHOT_CONTENT,
  EDIT_ARTICLE_PANEL_UPDATE_CONTENT_TEXT,
  EDIT_ARTICLE_PANEL_CREATE_ITEM,
  EDIT_ARTICLE_PANEL_SET_PREVIEW_OFFSET,
  EDIT_ARTICLE_PANEL_APPEND_CONTENT_NO_RECOVER,
  EDIT_ARTICLE_PANEL_PUSH_CONTRIBUTOR_NAME,
  EDIT_ARTICLE_PANEL_DEL_CONTRIBUTOR_NAME,
  EDIT_ARTICLE_PANEL_INSERT_IMAGE_ARR,
  EDIT_ARTICLE_PANEL_DEL_IMAGE_ARR,
  EDIT_ARTICLE_PANEL_SET_SUB_LOCKING_ID,
  EDIT_ARTICLE_PANEL_SET_SUB_ITEM,
  EDIT_ARTICLE_PANEL_SET_SUB_ITEM_TEXT,
  EDIT_ARTICLE_PANEL_UPDATE_SUB_ITEM_TEXT,
  EDIT_ARTICLE_PANEL_SET_PREVIEW_TEXT_LINE_IDS,
  EDIT_ARTICLE_PANEL_SET_PREVIEW_IMAGE_IDS,
  EDIT_ARTICLE_PANEL_SET_PREVIEW_ITEM_HIDING_MODE,
  EDIT_ARTICLE_PANEL_SET_ALL_PREVIEW_ITEM_HIDING_MODE
} from "../actionTypes";
import { mergeACDItem } from "../../model/ACDTypeUtil";
import {
  ACDTYPE_TEXT,
  ACDTYPE_IMAGE,
  ACDTYPE_VIDEO,
  ACDTYPE_AUDIO,
  ACDTYPE_IMAGE_ARR
} from "../../model/ACDTypes";
import {
  ACSTYPE_IMAGE,
  ACSTYPE_VIDEO,
  ACSTYPE_AUDIO
} from "../../model/ACSTypes";
import {
  saveArticleContentApi,
  delayedSaveArticleContentApi
} from "../../api/articles";
import { mergePageTextLineApi } from "../../api/pages";
import { generateUniqueID } from "../../utils/utils";
import { toast } from "react-toastify";
import { setMediaUsedAction } from "./pdfEditArticleAVList";

export const setAllPreviewingItemHidingMode = createAction(
  EDIT_ARTICLE_PANEL_SET_ALL_PREVIEW_ITEM_HIDING_MODE
);

export const setPreviewingItemHidingMode = createAction(
  EDIT_ARTICLE_PANEL_SET_PREVIEW_ITEM_HIDING_MODE
);

export const setPreviewingTextLineIDs = createAction(
  EDIT_ARTICLE_PANEL_SET_PREVIEW_TEXT_LINE_IDS
);

export const setPreviewingImageIDs = createAction(
  EDIT_ARTICLE_PANEL_SET_PREVIEW_IMAGE_IDS
);

export const changeArticleModeAction = createAction(
  EDIT_ARTICLE_PANEL_CHANGE_MODE
);
export const setEditingArticleAction = createAction(
  EDIT_ARTICLE_PANEL_SET_ARTICLE
);
export const snapShotEditArticleMetaAction = createAction(
  EDIT_ARTICLE_PANEL_SNAPSHOT_META
);
export const recoverLastEditArticleMetaAction = createAction(
  EDIT_ARTICLE_PANEL_RECOVER_META
);
export const recoverLastEditArticleContentAction = createAction(
  EDIT_ARTICLE_PANEL_RECOVER_CONTENT
);
export const updateArticleMetaTextAction = createAction(
  EDIT_ARTICLE_PANEL_UPDATE_META_TEXT
);
export const updateArticleMetaContributorNamesAction = createAction(
  EDIT_ARTICLE_PANEL_UPDATE_CONTRI_NAME
);
export const setLockingIDAction = createAction(EDIT_ARTICLE_PANEL_LOCK_ID);
export const apiSetACDTextAction = createAction(
  EDIT_ARTICLE_PANEL_API_SET_TEXT
);
export const setACDItemAction = createAction(EDIT_ARTICLE_PANEL_SET_ITEM);
export const appendContentACDItemAction = createAction(
  EDIT_ARTICLE_PANEL_APPEND_CONTENT
);
export const appendContentACDItemNoRecoverAction = createAction(
  EDIT_ARTICLE_PANEL_APPEND_CONTENT_NO_RECOVER
);
export const deleteContentAction = createAction(
  EDIT_PANEL_ARTICLE_DELETE_CONTENT
);
export const snapShotEditArticleContentAction = createAction(
  EDIT_ARTICLE_PANEL_SNAPSHOT_CONTENT
);
export const updateArticleContentTextAction = createAction(
  EDIT_ARTICLE_PANEL_UPDATE_CONTENT_TEXT
);
export const createManualItemAction = createAction(
  EDIT_ARTICLE_PANEL_CREATE_ITEM
);
export const setPreviewOffsetAction = createAction(
  EDIT_ARTICLE_PANEL_SET_PREVIEW_OFFSET
);
export const pushContributorNameAction = createAction(
  EDIT_ARTICLE_PANEL_PUSH_CONTRIBUTOR_NAME
);

export const deleteContributorNameAction = createAction(
  EDIT_ARTICLE_PANEL_DEL_CONTRIBUTOR_NAME
);

export const inserImageArrAction = createAction(
  EDIT_ARTICLE_PANEL_INSERT_IMAGE_ARR
);

export const deleteImageArrAction = createAction(
  EDIT_ARTICLE_PANEL_DEL_IMAGE_ARR
);

export const setSubLockingIDAction = createAction(
  EDIT_ARTICLE_PANEL_SET_SUB_LOCKING_ID
);

export const setACDSubItemAction = createAction(
  EDIT_ARTICLE_PANEL_SET_SUB_ITEM
);

export const apiSetACDSubItemTextAction = createAction(
  EDIT_ARTICLE_PANEL_SET_SUB_ITEM_TEXT
);

export const updateArticleContentSubTextAction = createAction(
  EDIT_ARTICLE_PANEL_UPDATE_SUB_ITEM_TEXT
);

export function saveArticleActionImmediate() {
  return async (dispatch, getState) => {
    const { editArticlePanel } = getState();
    const {
      metaEditHistory,
      contentEditHistory,
      articleID,
      blocking
    } = editArticlePanel;

    if (articleID == null) {
      return;
    }

    if (blocking) {
      toast.error(
        "Unable to save, please refresh.  Contact admin if problem persists."
      );
      return;
    }

    const metaDict = metaEditHistory[metaEditHistory.length - 1];
    const { itemIDs, itemsDict } = contentEditHistory[
      contentEditHistory.length - 1
    ];

    const itemList = itemIDs.map(anItemID => itemsDict[anItemID]);

    try {
      await delayedSaveArticleContentApi(articleID, metaDict, itemList, toast);
    } catch (e) {
      toast.error(e.toString());
    }
  };
}

export function saveArticleAction() {
  return async (dispatch, getState) => {
    const { editArticlePanel } = getState();
    const {
      metaEditHistory,
      contentEditHistory,
      articleID,
      blocking
    } = editArticlePanel;

    if (articleID == null) {
      return;
    }

    if (blocking) {
      toast.error(
        "Unable to save, please refresh.  Contact admin if problem persists."
      );
      return;
    }

    const metaDict = metaEditHistory[metaEditHistory.length - 1];
    const { itemIDs, itemsDict } = contentEditHistory[
      contentEditHistory.length - 1
    ];

    const itemList = itemIDs.map(anItemID => itemsDict[anItemID]);

    try {
      saveArticleContentApi(articleID, metaDict, itemList, toast);
    } catch (e) {
      toast.error(e.toString());
    }
  };
}

export function sendMediaRequestAction(media, issueID, articleID, toast) {
  return async (dispatch, getState) => {
    const { editArticlePanel } = getState();
    const { lockingID, mode, subLockingID } = editArticlePanel;

    if (mode !== "edit") {
      toast.error("cannot add media here");
      return;
    }

    if (lockingID == null) {
      const newID = generateUniqueID();

      dispatch(setMediaUsedAction({ mediaID: media.id, articleID }));
      dispatch(
        appendContentACDItemAction({
          textLineIDs: null,
          newID,
          page: 0,
          media: media,
          dataType: media.mediaType === "video" ? ACDTYPE_VIDEO : ACDTYPE_AUDIO,
          styleType:
            media.mediaType === "video" ? ACSTYPE_VIDEO : ACSTYPE_AUDIO,
          timeStamp: Date.now()
        })
      );
      dispatch(saveArticleAction());
    } else {
      const addingItem = {
        text: "",
        textLineIDs: null,
        media: media,
        dataType: media.mediaType === "video" ? ACDTYPE_VIDEO : ACDTYPE_AUDIO,
        styleType: media.mediaType === "video" ? ACSTYPE_VIDEO : ACSTYPE_AUDIO,
        isTextServerProcessed: true
      };

      const sendResult = await mergeToLockACDItem(
        mode,
        dispatch,
        getState,
        lockingID,
        addingItem,
        false,
        issueID,
        subLockingID,
        false,
        toast
      );

      if (sendResult) {
        dispatch(setMediaUsedAction({ mediaID: media.id, articleID }));
      }
    }
  };
}

function imageDuplicated(image, itemIDs, itemsDict) {
  for (let i = 0; i < itemIDs.length; i++) {
    const anItemID = itemIDs[i];
    const anItem = itemsDict[anItemID];

    if (anItem.dataType === ACDTYPE_IMAGE) {
      if (anItem.image.id === image.id) {
        return true;
      }
    } else if (anItem.dataType === ACDTYPE_IMAGE_ARR) {
      const imageArr = anItem.imageItemArr;

      for (let j = 0; j < imageArr.length; j++) {
        const subImageItem = imageArr[j];
        if (subImageItem.dataType === ACDTYPE_IMAGE) {
          if (subImageItem.image.id === image.id) {
            return true;
          }
        }
      }
    }
  }

  return false;
}

export function sendImageRequestAction(image, issueID, toast) {
  return async (dispatch, getState) => {
    const { editArticlePanel } = getState();
    const {
      lockingID,
      mode,
      subLockingID,
      contentEditHistory
    } = editArticlePanel;

    const { itemIDs, itemsDict } = contentEditHistory[
      contentEditHistory.length - 1
    ];

    if (mode === "preview") {
      toast.error("cannot add image here");
      return;
    }

    if (lockingID == null) {
      if (mode !== "edit") {
        toast.error("cannot add image here");
        return;
      }

      if (imageDuplicated(image, itemIDs, itemsDict)) {
        toast.error("This image is added alreday.");
        return;
      }

      const newID = generateUniqueID();

      dispatch(
        appendContentACDItemAction({
          textLineIDs: null,
          newID,
          page: 0,
          image: image,
          dataType: ACDTYPE_IMAGE,
          styleType: ACSTYPE_IMAGE,
          timeStamp: Date.now()
        })
      );
      dispatch(saveArticleAction());
    } else {
      if (mode === "edit" && imageDuplicated(image, itemIDs, itemsDict)) {
        toast.error("This image is added alreday.");
        return;
      }

      const addingItem = {
        text: "",
        textLineIDs: null,
        image: image,
        dataType: ACDTYPE_IMAGE,
        styleType: ACSTYPE_IMAGE,
        isTextServerProcessed: true
      };

      await mergeToLockACDItem(
        mode,
        dispatch,
        getState,
        lockingID,
        addingItem,
        false,
        issueID,
        subLockingID,
        false,
        toast
      );
    }
  };
}

export function sendMultiTextRequestAction(
  page,
  textLineIDs,
  acsType,
  issueID,
  toast
) {
  if (textLineIDs.length < 0) {
    toast.error("no text line id error");
    return;
  }

  return async (dispatch, getState) => {
    const { editArticlePanel } = getState();
    const { lockingID, mode } = editArticlePanel;

    if (mode === "meta") {
      toast.error("cannot send multi in metadata");
      return;
    } else if (mode === "edit") {
      if (lockingID == null) {
        await appendContentTextACDItem(
          dispatch,
          getState,
          page,
          textLineIDs,
          acsType,
          false,
          issueID,
          toast
        );
      } else {
        toast.error("cannot send multi to locking data");
      }
    } else {
      toast.error("cannot edit in preview mode");
      return;
    }
  };
}

export function sendTextRequestAction(
  page,
  textLineIDs,
  acsType,
  issueID,
  toast
) {
  if (textLineIDs.length < 0) {
    toast.error("no text line id error");
    return;
  }

  return async (dispatch, getState) => {
    const { editArticlePanel } = getState();
    const { lockingID, mode, subLockingID } = editArticlePanel;

    const addingItem = {
      text: "",
      textLineIDs: textLineIDs,
      dataType: ACDTYPE_TEXT,
      isTextServerProcessed: false
    };

    if (mode === "meta") {
      if (lockingID == null) {
        toast.error("cannot append in metadata");
        return;
      }

      await mergeToLockACDItem(
        mode,
        dispatch,
        getState,
        lockingID,
        addingItem,
        false,
        issueID,
        null,
        false,
        toast
      );
    } else if (mode === "edit") {
      if (lockingID == null) {
        await appendContentTextACDItem(
          dispatch,
          getState,
          page,
          textLineIDs,
          acsType,
          true,
          issueID,
          toast
        );
      } else {
        await mergeToLockACDItem(
          mode,
          dispatch,
          getState,
          lockingID,
          addingItem,
          false,
          issueID,
          subLockingID,
          false,
          toast
        );
      }
    } else {
      toast.error("cannot edit in preview mode");
      return;
    }
  };
}

export function sendOrderedTextRequestAction(
  page,
  textLineIDs,
  issueID,
  toast
) {
  if (textLineIDs.length < 0) {
    toast.error("no text line id error");
    return;
  }

  return async (dispatch, getState) => {
    const { editArticlePanel } = getState();
    const { lockingID, mode, subLockingID } = editArticlePanel;

    if (lockingID == null) {
      toast.error("ordered texts can only be sent to a locking item");
      return;
    }

    let combinedText = "";
    try {
      combinedText = await mergePageTextLineApi(issueID, textLineIDs);
    } catch (e) {
      toast.error(e.toString());
      return;
    }

    const addingItem = {
      text: combinedText.result,
      textLineIDs: textLineIDs,
      dataType: ACDTYPE_TEXT,
      isTextServerProcessed: true
    };

    if (mode === "meta") {
      await mergeToLockACDItemNoReorder(
        mode,
        dispatch,
        getState,
        lockingID,
        addingItem,
        issueID,
        null,
        toast
      );
    } else if (mode === "edit") {
      await mergeToLockACDItemNoReorder(
        mode,
        dispatch,
        getState,
        lockingID,
        addingItem,
        issueID,
        subLockingID,
        toast
      );
    } else {
      toast.error("cannot edit in preview mode");
      return;
    }
  };
}

export function mergeItemRequestAction(
  fromItemID,
  toItemID,
  issueID,
  concatOnly,
  toast
) {
  return async (dispatch, getState) => {
    const { editArticlePanel } = getState();
    const { mode } = editArticlePanel;

    if (mode === "meta") {
      return false;
    } else if (mode === "edit") {
      const { editArticlePanel } = getState();
      const { contentEditHistory } = editArticlePanel;
      const curSnapshot = contentEditHistory[contentEditHistory.length - 1];
      const dict = curSnapshot.itemsDict;

      const fromItem = dict[fromItemID];

      if (fromItem == null) {
        return false;
      }

      return await mergeToLockACDItem(
        mode,
        dispatch,
        getState,
        toItemID,
        fromItem,
        true,
        issueID,
        null,
        concatOnly,
        toast
      );
    } else {
      return false;
    }
  };
}

async function appendContentTextACDItem(
  dispatch,
  getState,
  page,
  textLineIDs,
  acsType,
  canRecover,
  issueID,
  toast
) {
  const newID = generateUniqueID();

  if (canRecover) {
    dispatch(
      appendContentACDItemAction({
        textLineIDs,
        newID,
        page,
        dataType: ACDTYPE_TEXT,
        styleType: acsType,
        timeStamp: Date.now()
      })
    );
    dispatch(saveArticleAction());
  } else {
    dispatch(
      appendContentACDItemNoRecoverAction({
        textLineIDs,
        newID,
        page,
        dataType: ACDTYPE_TEXT,
        styleType: acsType,
        timeStamp: Date.now()
      })
    );
    dispatch(saveArticleAction());
  }

  try {
    let combinedText = await mergePageTextLineApi(issueID, textLineIDs);

    dispatch(
      apiSetACDTextAction({
        mode: "edit",
        id: newID,
        text: combinedText.result,
        ready: true,
        orderedTextLineIDs: []
      })
    );
    dispatch(saveArticleAction());
  } catch (e) {
    dispatch(
      apiSetACDTextAction({
        mode: "edit",
        id: newID,
        text: "ERROR",
        ready: false
      })
    );
  }
}

async function mergeToLockACDItem(
  mode,
  dispatch,
  getState,
  toID,
  addingItem,
  deleteOld,
  issueID,
  subLockingID,
  concatOnly,
  toast
) {
  if (subLockingID != null) {
    return mergeToSubLockACDItem(
      mode,
      dispatch,
      getState,
      toID,
      addingItem,
      deleteOld,
      issueID,
      subLockingID,
      concatOnly,
      toast
    );
  }

  try {
    const { editArticlePanel } = getState();
    const { metaEditHistory, contentEditHistory } = editArticlePanel;

    let dict;
    if (mode === "edit") {
      const curSnapshot = contentEditHistory[contentEditHistory.length - 1];
      dict = curSnapshot.itemsDict;
    } else if (mode === "meta") {
      dict = metaEditHistory[metaEditHistory.length - 1];
    } else {
      return false;
    }
    const toACDItem = dict[toID];

    if (toACDItem == null) {
      dispatch(setLockingIDAction({ lockingID: null }));
      toast.error("to item null");
      return false;
    }

    const mergedACDItem = mergeACDItem(toACDItem, addingItem);

    if (mergedACDItem == null) {
      toast.error("cannot add into this item");
      return false;
    }

    if (concatOnly) {
      mergedACDItem.orderedTextLineIDs = combineOrderedTextLineIDs(
        toACDItem,
        addingItem
      );
    } else {
      mergedACDItem.orderedTextLineIDs = [];
    }

    dispatch(
      setACDItemAction({
        mode: mode,
        id: toID,
        item: mergedACDItem
      })
    );
    dispatch(saveArticleAction());

    if (deleteOld) {
      setTimeout(() => {
        dispatch(deleteContentAction({ id: addingItem.id, canRecover: false }));
        dispatch(saveArticleAction());
      }, 0);
    }

    if (concatOnly) {
      return;
    }

    if (mergedACDItem.isTextServerProcessed) {
      return true;
    }

    if (mergedACDItem.textLineIDs == null) {
      return true;
    }

    setTimeout(async () => {
      try {
        let combinedText = await mergePageTextLineApi(
          issueID,
          mergedACDItem.textLineIDs
        );

        dispatch(
          apiSetACDTextAction({
            mode: mode,
            id: toID,
            text: combinedText.result,
            ready: true,
            orderedTextLineIDs: []
          })
        );
        dispatch(saveArticleAction());
      } catch (e) {
        dispatch(
          apiSetACDTextAction({
            mode: mode,
            id: toID,
            text: "ERROR",
            ready: false
          })
        );
      }
    }, 0);

    return true;
  } catch (e) {
    dispatch(
      apiSetACDTextAction({
        mode: mode,
        id: toID,
        text: "ERROR",
        ready: false
      })
    );

    return false;
  }
}

async function mergeToSubLockACDItem(
  mode,
  dispatch,
  getState,
  toID,
  addingItem,
  deleteOld,
  issueID,
  subLockingID,
  concatOnly,
  toast
) {
  try {
    const { editArticlePanel } = getState();
    const { contentEditHistory } = editArticlePanel;

    let dict;
    if (mode === "edit") {
      const curSnapshot = contentEditHistory[contentEditHistory.length - 1];
      dict = curSnapshot.itemsDict;
    } else if (mode === "meta") {
      return false;
    } else {
      return false;
    }

    const toACDItem = dict[toID];

    if (toACDItem == null) {
      dispatch(setLockingIDAction({ lockingID: null }));
      toast.error("to item null");
      return false;
    }

    if (addingItem.dataType !== ACDTYPE_TEXT) {
      toast.error("cannot send this to sub-items");
      return false;
    }

    const toACDSubItemIdx = toACDItem.imageItemArr.findIndex(
      item => item.id === subLockingID
    );

    if (toACDSubItemIdx < 0) {
      dispatch(setSubLockingIDAction({ lockingID: null, subLockingID: null }));
      return false;
    }

    const toACDSubItem = toACDItem.imageItemArr[toACDSubItemIdx];

    const mergedACDSubItem = mergeACDItem(toACDSubItem, addingItem);

    if (mergedACDSubItem == null) {
      toast.error("cannot add into this item");
      return false;
    }

    if (concatOnly) {
      mergedACDSubItem.orderedTextLineIDs = combineOrderedTextLineIDs(
        toACDSubItem,
        addingItem
      );
    } else {
      mergedACDSubItem.orderedTextLineIDs = [];
    }

    dispatch(
      setACDSubItemAction({
        mode: mode,
        id: toID,
        subID: subLockingID,
        item: mergedACDSubItem
      })
    );
    dispatch(saveArticleAction());

    if (concatOnly) {
      return true;
    }

    if (mergedACDSubItem.isTextServerProcessed) {
      return true;
    }

    if (mergedACDSubItem.textLineIDs == null) {
      return true;
    }

    setTimeout(async () => {
      try {
        let combinedText = await mergePageTextLineApi(
          issueID,
          mergedACDSubItem.textLineIDs
        );

        dispatch(
          apiSetACDSubItemTextAction({
            mode: mode,
            id: toID,
            subID: subLockingID,
            text: combinedText.result,
            ready: true,
            orderedTextLineIDs: []
          })
        );
        dispatch(saveArticleAction());
      } catch (e) {
        dispatch(
          apiSetACDSubItemTextAction({
            mode: mode,
            id: toID,
            subID: subLockingID,
            text: "ERROR",
            ready: false
          })
        );
      }
    }, 0);

    return true;
  } catch (e) {
    console.log(e.toString());

    dispatch(
      apiSetACDSubItemTextAction({
        mode: mode,
        id: toID,
        subID: subLockingID,
        text: "ERROR",
        ready: false
      })
    );

    return false;
  }
}

async function mergeToSubLockACDItemNoReorder(
  mode,
  dispatch,
  getState,
  toID,
  addingItem,
  issueID,
  subLockingID,
  toast
) {
  try {
    const { editArticlePanel } = getState();
    const { contentEditHistory } = editArticlePanel;

    let dict;
    if (mode === "edit") {
      const curSnapshot = contentEditHistory[contentEditHistory.length - 1];
      dict = curSnapshot.itemsDict;
    } else if (mode === "meta") {
      return false;
    } else {
      return false;
    }

    const toACDItem = dict[toID];

    if (toACDItem == null) {
      dispatch(setLockingIDAction({ lockingID: null }));
      toast.error("to item null");
      return false;
    }

    if (addingItem.dataType !== ACDTYPE_TEXT) {
      toast.error("cannot send this to sub-items");
      return false;
    }

    const toACDSubItemIdx = toACDItem.imageItemArr.findIndex(
      item => item.id === subLockingID
    );

    if (toACDSubItemIdx < 0) {
      dispatch(setSubLockingIDAction({ lockingID: null, subLockingID: null }));
      return false;
    }

    const toACDSubItem = toACDItem.imageItemArr[toACDSubItemIdx];

    const toTextLineIDs = toACDSubItem.textLineIDs;
    const addingTextLineIDs = addingItem.textLineIDs;
    const toOrderedTextLineIDs = toACDSubItem.orderedTextLineIDs;

    const mergedACDSubItem = mergeACDItem(toACDSubItem, addingItem);

    if (mergedACDSubItem == null) {
      toast.error("cannot add into this item");
      return false;
    }

    if (toOrderedTextLineIDs == null || toOrderedTextLineIDs.length <= 0) {
      let newOrderedTextLineIDs = [];

      if (toTextLineIDs != null) {
        newOrderedTextLineIDs.push(toTextLineIDs);
      }

      if (addingTextLineIDs != null) {
        newOrderedTextLineIDs.push(addingTextLineIDs);
      }

      mergedACDSubItem.orderedTextLineIDs = newOrderedTextLineIDs;
    } else {
      if (addingItem.textLineIDs != null) {
        let newOrderedTextLineIDs = [...toOrderedTextLineIDs];
        newOrderedTextLineIDs.push(addingItem.textLineIDs);

        mergedACDSubItem.orderedTextLineIDs = newOrderedTextLineIDs;
      }
    }

    mergedACDSubItem.isTextServerProcessed = true;

    dispatch(
      setACDSubItemAction({
        mode: mode,
        id: toID,
        subID: subLockingID,
        item: mergedACDSubItem
      })
    );
    dispatch(saveArticleAction());

    return true;
  } catch (e) {
    console.log(e.toString());
    return false;
  }
}

async function mergeToLockACDItemNoReorder(
  mode,
  dispatch,
  getState,
  toID,
  addingItem,
  issueID,
  subLockingID,
  toast
) {
  if (subLockingID != null) {
    return mergeToSubLockACDItemNoReorder(
      mode,
      dispatch,
      getState,
      toID,
      addingItem,
      issueID,
      subLockingID,
      toast
    );
  }

  try {
    const { editArticlePanel } = getState();
    const { metaEditHistory, contentEditHistory } = editArticlePanel;

    let dict;
    if (mode === "edit") {
      const curSnapshot = contentEditHistory[contentEditHistory.length - 1];
      dict = curSnapshot.itemsDict;
    } else if (mode === "meta") {
      dict = metaEditHistory[metaEditHistory.length - 1];
    } else {
      return false;
    }
    const toACDItem = dict[toID];

    if (toACDItem == null) {
      dispatch(setLockingIDAction({ lockingID: null }));
      toast.error("to item null");
      return false;
    }

    const toTextLineIDs = toACDItem.textLineIDs;
    const addingTextLineIDs = addingItem.textLineIDs;
    const toOrderedTextLineIDs = toACDItem.orderedTextLineIDs;

    const mergedACDItem = mergeACDItem(toACDItem, addingItem);

    if (mergedACDItem == null) {
      toast.error("cannot add into this item");
      return false;
    }

    if (toOrderedTextLineIDs == null || toOrderedTextLineIDs.length <= 0) {
      let newOrderedTextLineIDs = [];

      if (toTextLineIDs != null) {
        newOrderedTextLineIDs.push(toTextLineIDs);
      }

      if (addingTextLineIDs != null) {
        newOrderedTextLineIDs.push(addingTextLineIDs);
      }

      mergedACDItem.orderedTextLineIDs = newOrderedTextLineIDs;
    } else {
      if (addingItem.textLineIDs != null) {
        let newOrderedTextLineIDs = [...toOrderedTextLineIDs];
        newOrderedTextLineIDs.push(addingItem.textLineIDs);
        mergedACDItem.orderedTextLineIDs = newOrderedTextLineIDs;
      }
    }

    mergedACDItem.isTextServerProcessed = true;

    dispatch(
      setACDItemAction({
        mode: mode,
        id: toID,
        item: mergedACDItem
      })
    );
    dispatch(saveArticleAction());

    return true;
  } catch (e) {
    console.log(e.toString());
    return false;
  }
}

function combineOrderedTextLineIDs(firstItem, secondItem) {
  let result = [];

  if (
    firstItem.orderedTextLineIDs != null &&
    firstItem.orderedTextLineIDs.length > 0
  ) {
    result = result.concat(firstItem.orderedTextLineIDs);
  } else {
    if (firstItem.textLineIDs != null) {
      result.push(firstItem.textLineIDs);
    }
  }

  if (
    secondItem.orderedTextLineIDs != null &&
    secondItem.orderedTextLineIDs.length > 0
  ) {
    result = result.concat(secondItem.orderedTextLineIDs);
  } else {
    if (secondItem.textLineIDs != null) {
      result.push(secondItem.textLineIDs);
    }
  }

  return result;
}
